import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", as: Tag = "div" }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.2 }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {Tag === "div" ? children : <Tag>{children}</Tag>}
  </motion.div>
);

export const SectionLabel = ({ children, className = "" }) => (
  <div
    className={`text-xs uppercase tracking-[0.22em] font-semibold text-[#5C5E58] flex items-center gap-3 ${className}`}
  >
    <span className="w-8 h-px bg-[#F08722]" />
    {children}
  </div>
);
